import styled from 'styled-components';

import { Text } from '../../../../components';
import { COLORS, MOBILE, SPACE, STATUS_COLORS } from '../../../../theme/tokens';
import { SCORE_COLOR } from '../RouteList/RouteList.styles';

export type ScoreTone = keyof typeof SCORE_COLOR;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACE[12]};
  flex-wrap: wrap;
`;

export const Score = styled.span<{ $tone: ScoreTone }>`
  font-size: 13px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: ${({ $tone }) => SCORE_COLOR[$tone]};
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[16]};
  margin-top: ${SPACE[16]};
`;

export const FieldBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
`;

export const TagRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACE[8]};
  flex-wrap: wrap;
`;

export const Prompt = styled(Text)`
  font-size: 13px;
  color: ${COLORS.textMuted};
`;

export const Checklist = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Row = styled.li`
  display: flex;
  align-items: flex-start;
  gap: ${SPACE[8]};
  min-width: 0;
  font-size: 13px;
  color: ${COLORS.text};
`;

export const Mark = styled.span<{ $ok: boolean | null }>`
  display: inline-flex;
  flex-shrink: 0;
  /* One pixel down: optical alignment of the 14px icon with the 13px text's first line. */
  margin-top: 1px;
  color: ${({ $ok }) => ($ok === null ? COLORS.textMuted : $ok ? STATUS_COLORS.positive : COLORS.danger)};
`;

export const RowText = styled.span`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  column-gap: ${SPACE[8]};
  min-width: 0;
  overflow-wrap: anywhere;
`;

export const Detail = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textMuted};
`;

export const Info = styled(Checklist)`
  padding-top: ${SPACE[12]};
  border-top: 1px solid ${COLORS.surfaceMuted};

  ${MOBILE} {
    padding-top: ${SPACE[8]};
  }
`;
